<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <div class="row">
    <h3 class="col">Operação de Repasse</h3>
    <div class="col-auto" *ngIf="permissaoEnvio">
      <!-- <button class="btn btn-danger">Cancelar</button> -->
      <button class="btn btn-primary" (click)="protocolar(true)" [disabled]="!this.formOperacaoRepasse.valid">Validar</button>
      <button class="btn btn-primary" (click)="protocolar(false)" [disabled]="!this.formOperacaoRepasse.valid">Protocolar</button>
      <button class="btn btn-primary" (click)="contratar()" [disabled]="!this.formOperacaoRepasse.valid || !podeContratar()">Contratar</button>
      <button class="btn btn-danger" (click)="cancelar()" [disabled]="!podeCancelar()">Cancelar</button>
    </div>
  </div>
  <form [formGroup]="formOperacaoRepasse" class="bn-form-group">
    <div class="row">
      <ul ngbNav #nav="ngbNav" class="col nav-tabs">
        <li [ngbNavItem]="'operacao-garantida'" id="operacao-garantida" title="Operação garantida">
          <button ngbNavLink>Operacao garantida</button>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-md-3">
                <label class="form-label"><b>Identificador <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Identificador único da operação no sistema de origem."></i></b></label>
                <input type="text" class="form-control" formControlName="idProtocoloBNDES" maxlength="17" (keydown.tab)="preencherFormulario()" required>
              </div>
              <div class="col-md-3">
                <label class="form-label"><b>Sistema de origem</b></label>
                <select class="form-select" formControlName="sistemaOrigem">
                  <option value=""></option>
                  <option value="N03">N03</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label"><b>Agente Financeiro</b></label>
                <select class="form-select" formControlName="cnpjAgenteFinanceiro" bn-valid-cnpj required>
                  <option value=""></option>
                  <option [value]="agente.cnpj" *ngFor="let agente of agentesFinanceiros">
                      {{ agente.nome }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 bn-form-group">
                <label class="form-label"><b>Valor da operação</b></label>
                <input type="text" class="form-control" formControlName="valorOperacao" bnMask="MOEDA" required>
              </div>
              <div class="bn-form-group col-md-3">
                <label class="form-label" for="percentualGarantidoSelect"><b>Percentual garantido <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Percentual garantido da operação"></i></b></label>
                <select class="form-select" formControlName="percentualGarantido" required >
                  <option [value]="percentualPorModalidade" *ngFor="let percentualPorModalidade of percentuaisPorModalidade">{{percentualPorModalidade }}
                  </option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label" for="percentualGarantidoSelect"><b>Risco operação <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Risco da operação. Informe este campo ou o valor da perda esperada."></i></b></label>
                <select class="form-select" formControlName="riscoOperacao">
                  <option value=""></option>
                  <option [value]="risco" *ngFor="let risco of classificacoesRisco">{{ risco }}</option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Valor perda esperada <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Valor percentual da perda esperada (nova forma de informe de risco). Informe este campo ou o valor do risco."></i></b></label>
                <input type="text" class="form-control pe-4" formControlName="valorPerdaEsperada" bnMask="MOEDA">
              </div>
              <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Data contratação</b></label>
                <bn-datepicker formControlName="dataContratacao">
                </bn-datepicker>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Programa</b></label>

                <select class="form-select" formControlName="idPrograma" required>
                  <option *ngFor="let programa of programasAceitos" [value]="programa.id">
                     {{  programa.id  + ' - ' + (programa.descricaoPrograma || 'nome indefinido')  }}
                  </option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Modalidade operacional</b></label>

                <select class="form-select" formControlName="idModalidadeOperacionalBndes" required>
                  <option *ngFor="let modalidade of modalidadesOperacionaisAceitas" [value]="modalidade.id">
                     {{  modalidade.id  + ' - ' + (modalidade.nome || 'nome indefinido')  }}
                  </option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Qtd. de meses prazo total</b></label>
                <input type="text" class="form-control" formControlName="quantidadeMesesPrazoTotal" bnMask="INTEIRO" required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Qtd. de meses prazo carência</b></label>
                <input type="text" class="form-control" formControlName="quantidadeMesesPrazoCarencia" bnMask="INTEIRO" required>
              </div>
            </div>
            <div class="row">
              <div class="bn-form-group col-md-6"> 
                <label class="form-label" for="composicaoGarantiasSelect"><b>Composição de garantias</b></label>
                <select id="composicaoGarantiasSelect" class="form-select" formControlName="composicaoGarantia">
                  <option value=""></option>
                  <option [value]="composicao.codigo" *ngFor="let composicao of composicoesGarantia">{{ composicao.codigo }} - {{ composicao.descricao }}</option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label" for="garantiasSelect"><b>Principal garantia operação <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Refere-se à garantia sem contar o fundo garantidor (caso possua ou seja necessário)."></i></b></label>
                <select id="garantiasSelect" class="form-select" formControlName="principalGarantiaOperacao">
                  <option value=""></option>
                  <option [value]="garantia.codigo" *ngFor="let garantia of garantias">{{ garantia.codigo }} - {{ garantia.descricao }}</option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Percent. cobert. gart. principal <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Percentual de cobertura da garantia principal. Refere-se à garantia sem contar o fundo garantidor (caso possua ou seja necessário)."></i></b></label>
                <input type="text" class="form-control" formControlName="percentualCobertoGarantiaPrincipal" bnMask="DECIMAL" casasDecimais="2">
              </div>
            </div>
            <div class="row">
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Pagamento de juros carência</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" formControlName="pagamentoJurosCarencia">
              </div>
              <div class="col-md-3">
                <label class="form-label"><b>Unidade monetária</b></label>
                <select class="form-select" formControlName="ideCustoFinanceiroProtocolo">
                  <option value=""></option>
                  <option value="19">Real</option>
                  <option value="145">Real SELIC</option>
                  <option value="777">TLP</option>
                </select>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa spread agente</b></label>
                <input type="text" class="form-control" formControlName="taxaSpreadAgente" bnMask="DECIMAL" casasDecimais="2" required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa intermediação BNDES</b></label>
                <input type="text" class="form-control" formControlName="taxaIntermediacaoBNDES" bnMask="DECIMAL" casasDecimais="2" required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa remuneração básica BNDES</b></label>
                <input type="text" class="form-control" formControlName="taxaRemuneracaoBasicaBNDES" bnMask="DECIMAL" casasDecimais="2" required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa remuneração BNDES</b></label>
                <input type="text" class="form-control" formControlName="taxaRemuneracaoBNDES" bnMask="DECIMAL" casasDecimais="2" required disabled>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa custo financeiro adicional</b></label>
                <input type="text" class="form-control" formControlName="taxaCustoFinanceiroAdicional" bnMask="DECIMAL" casasDecimais="2" required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Taxa Cobrança BNDES <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Taxa de Cobrança BNDES (% a.a.) = Trata-se da taxa de juros (custo financeiro BNDES) que o BNDES cobrará do Agente Financeiro na Operação. Ela é composta pela Taxa de remuneração BNDES e pela Taxa de custo financeiro adicional  vinculada a linha de financiamento."></i></b></label>
                <input type="text" class="form-control" formControlName="taxaReferencialCustoFinanceiro" bnMask="DECIMAL" casasDecimais="2">
              </div>            
            </div>
            <div class="mt-3">
              <h5>Dados obrigatórios apenas para a contratação</h5>
              <div class="row">
                <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Sistema cobrança</b></label>
                <select class="form-select" formControlName="sistemaCobranca">
                  <option value=""></option>
                  <option value="15">15</option>
                  <option value="89">89</option>
                </select>
                </div>
                <div class="bn-form-group col-md-3"> 
                  <label class="form-label"><b>Contrato cobrança:</b></label>
                  <input type="text" class="form-control" formControlName="contratoCobranca" maxlength="11">
                </div>
                <div class="bn-form-group col-md-3"> 
                  <label class="form-label"><b>Data da primeira amortização</b></label>
                  <bn-datepicker [minDate]="dataFuturaPrimeiraAmortizacao" formControlName="dataPrimeiraAmortizacao">
                  </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3"> 
                  <label class="form-label"><b>Data da última amortização</b></label>
                  <bn-datepicker [minDate]="dataFuturaUltimaAmortizacao" formControlName="dataUltimaAmortizacao">
                  </bn-datepicker>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'cliente'" title="Cliente" title="Cliente">
          <button ngbNavLink>Cliente</button>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>CNPJ</b></label>
                <input type="text" class="form-control" formControlName="cnpjClienteFinal" bn-mask-cnpj bn-valid-cnpj required>
              </div>
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>CNAE</b></label>
                <input type="text" class="form-control"
                (selectItem)="atribuiCnaeClienteFinal($event)"
                value="{{cnaeClienteFinal}} - {{nomeCnaeClienteFinal}}"
                [ngbTypeahead]="procuraCnae" [resultFormatter]="formataCnae" />
                <input type="text" formControlName="cnaeClienteFinal" hidden>
              </div>   
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Porte cliente final</b></label>
                <select class="form-select" formControlName="idPorteClienteFinal" required>
                  <option value=""></option>
                  <option [value]="porteClienteFinal.id" *ngFor="let porteClienteFinal of portesClienteFinal">
                    {{ porteClienteFinal.label }}
                  </option>
                </select>
              </div>    
              <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Natureza da empresa</b></label>
                <select class="form-select" formControlName="naturezaEmpresa" [compareWith]="compararNaturezas" required>
                  <option [ngValue]="null"></option>
                  <option *ngFor="let natureza of naturezasJuridicasAceitas" [ngValue]="natureza">
                    {{ natureza.nome }}{{ natureza.idComplementoN02 >= 0 ? ' - Complemento: ' + natureza.idComplementoN02 : '' }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="bn-form-group col-md-3"> 
                <label class="form-label"><b>Receita bruta <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Receita bruta original da operação."></i></b>
                </label>
                <input type="text" class="form-control" formControlName="receitaBrutaClienteFinal" bnMask="MOEDA" required>
              </div>
              <div class="bn-form-group col-md-3">
                <label class="block form-label"><b>Tipo da receita bruta</b></label>
                <select class="form-select" formControlName="tipoReceitaBruta" required>
                  <option value=""></option>
                  <option value="E">Efetiva</option>
                  <option value="P">Prevista</option>
                </select>
              </div>
              <div class="bn-form-group col-md-3">
                <label class="block form-label"><b>Data da receita bruta</b></label>
                <bn-datepicker formControlName="dataReferenciaReceitaBruta" required></bn-datepicker>
              </div>
            </div>           
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-4 text-muted small"><label class="form-label"><b>* Campos obrigatórios</b></label></div>
    </div>
  </form>
</div>